import type { WorkflowAttachment } from '../model';

export function workflowAttachmentFingerprint(attachment: WorkflowAttachment) {
  return JSON.stringify([
    attachment.id, attachment.displayName, attachment.contentType,
    attachment.sizeBytes, attachment.scanStatus, attachment.createdAt,
  ]);
}

/** 조회한 뒤에도 남아 있고 변경되지 않은 파일만 갱신합니다. 추가·삭제된 파일은 현재 목록을 따릅니다. */
export function mergeWorkflowAttachmentRefresh(
  current: readonly WorkflowAttachment[],
  requested: readonly WorkflowAttachment[],
  refreshed: readonly WorkflowAttachment[],
): WorkflowAttachment[] {
  const requestedByID = new Map(requested.map((attachment) => [attachment.id, workflowAttachmentFingerprint(attachment)]));
  const refreshedByID = new Map(refreshed.map((attachment) => [attachment.id, attachment]));
  return current.map((attachment) => {
    const fingerprint = workflowAttachmentFingerprint(attachment);
    const refreshedAttachment = refreshedByID.get(attachment.id);
    return requestedByID.get(attachment.id) === fingerprint && refreshedAttachment
      && workflowAttachmentFingerprint(refreshedAttachment) !== fingerprint
      ? refreshedAttachment
      : attachment;
  });
}
